import type {
  TabPanelClasses as MuiTabPanelClasses,
  TabPanelProps as MuiTabPanelProps,
} from '@mui/lab/TabPanel';

import MuiTabPanel from '@mui/lab/TabPanel';

import { useTabsContext } from './TabsContext';
import './TabsPanel.scss';
const classes = { root: 'Mfw-TabsPanel-root' } as MuiTabPanelClasses;

export type TabsPanelProps = MuiTabPanelProps;
const TabsPanel = ({ children, className, sx, value }: TabsPanelProps) => {
  const { value: currentValue } = useTabsContext();

  if (currentValue !== value) return null;
  return (
    <MuiTabPanel className={className} classes={classes} value={value} sx={sx}>
      {children}
    </MuiTabPanel>
  );
};

export default TabsPanel;
